import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

import {BooleanValueCell} from './BooleanValueCell'

export const IntermediateAndFinishedProductsClassificationRow = ({
  material
}: {
  material: Material
}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.selection}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.category}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">
        {material.classification?.methodOfFinenessDetermination}
      </Typography>
    </TableCell>
    <BooleanValueCell value={material.classification?.intermediateMillProduct} />
    <TableCell>
      <Typography variant="caption">
        {material.classification?.referenceMeshSizeForResidue}
      </Typography>
    </TableCell>
  </>
)
